/* eslint-disable camelcase */
export default {
	definite: '确定',
	prompt: '提示',
	confirm_deletion: '单据删除后将不能恢复，是否确认删除?',
	create_order: 'Create Order',
	create: 'Create',
	cancel: 'Cancel',
	procurement_bu: 'Procurement BU',
	Supplier: 'Supplier',
	supplier_Contact: 'Supplier Contact',
	Default_Ship_to_Location: 'Default Ship-to Location',
	Sold_to_Legal_Entity: 'Sold-to Legal Entity',
	Currency: 'Currency',
	Buyer: 'Buyer',
	Default_Purpose: 'Default Purpose',
	Enter_a_keyword: 'Enter a keyword',
	More: 'More',
	order_management: '采购订单',
	support_agreement: '关联合同禁止选择补充协议',
	Home: 'Home',
	confirm_s: '确定',
	order_entry: '创建订单',
	General: 'General',
	not_now: '现在不选',
	ConversionRateType: 'Conversion Rate Type',
	BillToLocation: 'Bill-to Location',
	BillToBU: 'Bill-to BU',
	confirm_the: '确认',
	CommunicationMethod: 'Communication Method',
	ConversionDate: 'Conversion Date',
	ConversionRate: 'Conversion Rate',
	Order: 'Order',
	Ordered: 'Ordered',
	Status: 'Status',
	TotalTax: 'Total Tax',
	FundsStatus: 'Funds Status',
	Total: 'Total',
	CreationDate: 'Creation Date',
	description: 'Description',
	SearchAndSelectSupplier: 'Search and Select:Supplier',
	SupplierNumber: 'Supplier Number',
	Search: 'Search',
	Reset: 'Reset',
	SupplierType: 'Supplier Type',
	ApplyBG: 'Apply BG',
	Ok: 'Ok',
	SearchAndSelectSupplierContact: 'Search and Select:Supplier Contact',
	Name: 'Name',
	Phone: 'Phone',
	EMail: 'E-Mail',
	Address: 'Address',
	SearchAndSelectDefaultShipToLocation: 'Search and Select:Default Ship-to Location',
	SearchAndSelectBuyer: 'Search and Select:Buyer',
	Department: 'Department',
	Joby: 'Joby',
	ThisIsA: 'This is a …',
	AdditionalInformation: 'Additional Information',
	BGInCharge: 'BG in Charge',
	DepartmentInCharge: 'Department in Charge',
	PurchaseType: 'Purchase Type',
	Contract: 'Contract',
	PaymentTerms: 'Payment Terms',
	NotesAndAttachments: 'Notes and Attachments',
	Edit: 'Edit',
	Line: 'Line',
	Item: 'Item',
	Description: 'Description',
	Quantity: 'Quantity',
	UOM: 'UOM',
	Price: 'Price',
	TaxCode: 'Tax Code',
	UnitPriceTaxIncluded: 'Unit Price(tax included)',
	Location: 'Location',
	RequestedDeliveryDate: 'Requested Delivery Date',
	PromisedDeliveryDate: 'Promised Delivery Date',
	Purpose: 'Purpose',
	BudgetDate: 'Budget Date',
	CostCenter: 'Cost Center',
	BudgetAccount: 'Budget Account',
	POChargeAccount: 'PO Charge Account',
	FundStatus: 'Fund Status',
	SuggestedSupplier: 'Suggested Supplier',
	Type: 'Type',
	NoteOrFile: 'Note or File',
	Title: 'Title',
	AttachedBy: 'Attached By',
	AttachedDate: 'Attached Date',
	NoDataSelected: '请选择一行数据',
	Lines: 'Lines',
	ApprovalHistory: 'Approval History',
	User: 'User',
	Post: 'Post',
	Setp: 'Setp',
	Option: 'Option',
	ApprovedDate: 'Approved Date',
	ConsumingTime: 'Consuming Time',
	CurrentUser: 'Current User',
	OrderReview: '浏览订单',
	Manageorders: '管理订单',
	CreateShipToLocation: 'Create Ship-to Location',
	Save: 'Save',
	AddressCannotBeEmpty: 'Address cannot be empty',
	NameCannotBeEmpty: 'Name cannot be empty',
	PhoneCannotBeEmpty: 'Phone cannot be empty',
	EmailCannotBeEmpty: 'E-Mail cannot be empty',
	EnterTheRequiredField: 'Enter the required field',
	SavedSuccessfully: 'Saved successfully',
	PleaseSelectAPurchasingBusinessUnit: '请选择采购业务单位',
	SelectTheSupplier: 'Select the supplier',
	PleaseSelectASupplierContact: '请选择供应商联系人',
	SelectTheCurrency: 'Select the currency',
	SearchResults: 'Search Results',
	ContractNumber: 'Contract Number',
	Pleaseselectabuyer: '请选择采购员',
	to: 'To',
	start_date: 'Start Date',
	end_date: 'End Date',
	this_operation_cannot_be_resumed_do_you_want_to_continue: 'This operation cannot be recovered. Continue?',
	confirm: 'Confirm',
	deleted_successfully: 'Deleted successfully.',
	it_may_take_a_long_time_to_export_please_wait:
		"Export may take some time. Please wait. (Do not close the page or click the 'Export' button again.)",
	CreatedSuccessfully: '创建成功',
	Select: 'Select',
	Node: 'Node',
	Fax: 'Fax',
	Print: 'Print',
	Other: 'Other',
	PleaseSelectTheReceivingLocation: '请选择收单地点',
	PleaseChooseSupervisorBg: '请选择主管bg',
	PleaseSelectACompetentAuthority: '请选择主管部门',
	PleaseSelectAPurchaseCategory: '请选择采购类别',
	SelectTheAssociatedContract: 'Select the associated contract',
	SelectThePaymentTerms: 'Select the payment terms',
	Text: 'Text',
	File: 'File',
	EnterTheTitle: 'Enter the title',
	EnterTheNote: 'Enter the note ',
	chooseFile: 'choose file',
	UploadAttachment: 'Upload Attachment',
	SelectTheMaterialCode: 'Select the material code',
	SearchAndSelectItem: 'Search and Select：Item',
	ItemDescription: 'Item Description',
	EnterTheQuantity: 'Enter the quantity',
	QuantityCannotBe0: 'Quantity cannot be 0',
	EnteTthePrice: 'Enter the price',
	PriceCannotBe0: 'Price cannot be 0',
	SelectTheTaxCode: 'Select the tax code',
	SelectDeliveryAddress: 'Select the delivery address',
	SelectADate: 'Select a date',
	SearchAndSelectPurpose: 'Search and Select：Purpose',
	PurposeName: 'Purpose Name',
	PurposeType: 'Purpose Type',
	CheckingType: 'Checking Type',
	EnableFlag: 'Enable Flag',
	BudgetControl: 'Budget Control',
	Visible: 'Visible',
	SelectThePurpose: 'Select the purpose',
	SearchAndSelectCostCenter: 'Search and Select：Cost Center',
	Value: 'Value',
	SelectTheCostCenter: 'Select the cost center',
	SelectTheBudgetAccount: 'Select the budget account',
	Comment: 'Comment',
	NotReserved: 'Not reserved',
	Passed: 'Passed',
	AmazonPunchOut: 'Amazon(PunchOut)',
	All: 'All',
	Approved: 'Approved',
	Canceled: 'Canceled',
	Incomplete: 'Incomplete',
	PendingApproval: 'Pending approval',
	Rejected: 'Rejected',
	Returned: 'Returned',
	Withdrawn: 'Withdrawn',
	PleaseSelectAnOrderWithDraftStatus: '请选择状态为草稿的订单',
	Account: 'Account',
	CreditName: 'Credit Name',
	LatestPayDate: 'Latest Pay Date',
	PayCurrency: 'Pay Currency',
	CreditDays: 'Credit Days',
	SelectTheAccount: 'Select the account',
	SelectTheCreditName: 'Select the credit name',
	SelectThePayCurrency: 'Select the pay currency',
	SelectTheCreditDays: 'Select the credit days',
	PleaseSelectTheSupplierFirst: 'Please select the supplier first',
	IndividualTaxAmount: 'Individual Tax Amount',
	EditLine: 'Edit Line',
	Back: 'Back',
	Next: 'Next',
	EditDocumentPurchaseOrder: 'Edit Document (Purchase Order)',
	CheckFunds: 'Check Funds',
	ViewPDF: 'View PDF',
	Actions: 'Actions',
	Submit: 'Submit',
	Validate: 'Validate',
	Duplicate: 'Duplicate',
	Delete: 'Delete',
	CheckList: 'Check List',
	InputRequiredGeneral: 'Input Required-General',
	InputRequiredAdditionalInformation: 'Input Required-Additional Information',
	InputRequiredLine: 'Input Required-Line',
	BudgetLine: 'Budget-Line',
	PoinChargeLine: 'PO in Charge-Line',
	checkItem: 'Check Item',
	CheckResult: 'Check Result',
	NotPassed: 'Not Passed',
	CheckDescription: 'Check Description',
	Done: 'Done',
	InputRequiredAttachmentInformation: 'Input Required-Attachment Information',
	PleaseAddOrderDetails: '请添加订单明细',
	EnterTheRequiredFields: 'Enter the required fields',
	SubmittedSuccessfully: 'Submitted successfully',
	CopySuccessfully: 'Copy successfully',
	Acknowledge: 'Acknowledge',
	Withdraw: 'Withdraw',
	Agree: 'Agree',
	Reject: 'Reject',
	approvalOpinionsMustBeEnteredForRejection: 'Enter the comments for rejection',
	handled_successfully: 'Processed successfully',
	ThereAreNoSavedDetailsAndCannotBeExported: '暂无已保存的明细,无法导出',
	TheCurrentUserHasNoPermission: '当前用户暂无权限',
	orgName: 'Org',
	TemplateDescription: '模板描述',
	Whethertoenable: '是否启用',
	Placeofpurchase: '采购地点',
	summary: 'Summary',
	summary_approval_status: 'Summary approval status',
	abstract_date: 'Summary date',
	include_order_date: 'Include order date',
	include_order_number: 'Include order number',
	include_our_subject: 'Include our subject',
	include_supplier: 'Include supplier',
	number_of_order: 'Number of order',
	summary_information: 'Summary information',
	summarize_the_purchase_amount: 'Purchase amount',
	approval_status: 'Approval status',
	summary_order_list: 'Summary order list',
	generate_summary: 'Generate summary',
	not_transferable_to_the_current_processor: 'Not transferable to the current processor',
	please_input_turnover: 'Please input turnover',
	please_input_rejected: 'Please input rejected',
	please_enter_required: 'Please enter required',
	clickCopy: 'Click copy',
	CopySuccess: 'Copy success',
	CopyFail: 'Copy fail',
	summaryId: 'Summary id',
	custom_search: 'Custom search',
	recently_used: 'Recently used',
	order: 'order',
	look_more: 'See more',
	consulting_feedback: 'Consulting feedback',
	operation_manual: 'Operation Manual',
	internet_operation_manual: '网络协同操作手册',
	procurement_system_user_manual: '采购系统《系统使用手册》',
	personal_work: 'Personal work',
	pending_approval_documents: 'Pending approval',
	other_pending_approval: 'Other agent',
	quick_entry: 'Quick entry',
	add_quick_entry: 'Add quick entry',
	my_frequently_used_functions: 'My frequently used functions',
	query_entry: 'Query entry',
	create_entry: 'Create entry',
	draft_entry: 'Draft entry',
	Optionalmaterialcategory: '可选物料类别',

	// 税务台账待办
	to_do_status: 'to do status'
};
